/**
 * TECHS の手配番号（受注票の番号）— 画面側の正規化と判定。
 * 決まりの本体はサーバー（`services/tehai_no.py`）。ここは入力の手触りのためだけに
 * 同じ形を1か所で持つ（`/api/mfg/issue-reasons` が返す `pattern` があればそれを使う）。
 *
 * 形: 0〜3 で始まる 9桁の数字。例) 026100105 / 326040253 / 126000045
 */
export const TEHAI_FIRST_DIGITS = ['0', '1', '2', '3'];
export const TEHAI_LENGTH = 9;
export const TEHAI_PATTERN = `^[${TEHAI_FIRST_DIGITS.join('')}]\\d{${TEHAI_LENGTH - 1}}$`;
export const TEHAI_HINT = `${TEHAI_FIRST_DIGITS[0]}〜${TEHAI_FIRST_DIGITS[TEHAI_FIRST_DIGITS.length - 1]}で始まる${TEHAI_LENGTH}桁の数字`;
export const TEHAI_FORMAT_ERROR = `手配番号の形式が違います（${TEHAI_FIRST_DIGITS[0]}〜${TEHAI_FIRST_DIGITS[TEHAI_FIRST_DIGITS.length - 1]}で始まる${TEHAI_LENGTH}桁の数字）`;
export const TEHAI_MISSING_ERROR = '手配番号を入力してください（製造使用・試作使用では必須です）';

const ZEN = '０１２３４５６７８９';

export function normalizeTehai(value) {
  return String(value || '').replace(/[０-９]/g, (c) => String(ZEN.indexOf(c)))
    .replace(/[\s\u3000-]/g, '').replace(/ー/g, '');
}

/** 空文字なら null（required は呼び手が見る）。だめなら理由の文字列を返す。 */
export function tehaiError(value, { required = false, pattern = TEHAI_PATTERN } = {}) {
  const no = normalizeTehai(value);
  if (!no) return required ? TEHAI_MISSING_ERROR : null;
  if (!new RegExp(pattern).test(no)) return TEHAI_FORMAT_ERROR;
  return null;
}
